import { isLogoWidget } from '@kaltura-ott/tvpil-shared';

export function checkIsLogoRailV2(categoryTree: any) {
  return isLogoWidget(categoryTree);
}
